module.exports = __webpack_public_path__ + "img/emoji-shake-hands-240x240.b1a70a98.png";